import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')

// const MaintenancePage = () => import('@/views/MaintenancePage')
const PrivacyPolicy = () => import('@/views/PrivacyPolicy')

const Categories = () => import('@/views/categories/Categories')
const AddCategory = () => import('@/views/categories/AddCategory')
const EditCategory = () => import('@/views/categories/EditCategory')

const PointsOfInterest = () => import('@/views/pois/PointsOfInterest')
const AddPointOfInterest = () => import('@/views/pois/AddPointOfInterest')
const EditPointOfInterest = () => import('@/views/pois/EditPointOfInterest')

const Members = () => import('@/views/Members/MembersList')
const MembersAdd = () => import('@/views/Members/MembersAdd')
const MembersEdit = () => import('@/views/Members/MembersEdit')

const Heros = () => import('@/views/Heros/HerosList')
const HerosAdd = () => import('@/views/Heros/HerosAdd')
const HerosEdit = () => import('@/views/Heros/HerosEdit')

const KeyValues = () => import('@/views/KeyValues/KeyValuesList')
const KeyValuesAdd = () => import('@/views/KeyValues/KeyValuesAdd')
const KeyValuesEdit = () => import('@/views/KeyValues/KeyValuesEdit')

const Products = () => import('@/views/products/Products')
const AddProduct = () => import('@/views/products/AddProduct')
const EditProduct = () => import('@/views/products/EditProduct')

const Experiences = () => import('@/views/experiences/ExperiencesList')
const ExperiencesAdd = () => import('@/views/experiences/ExperiencesAdd')
const ExperiencesEdit = () => import('@/views/experiences/ExperiencesEdit')

const Testimonials = () => import('@/views/testimonials/TestimonialsList')
const TestimonialsAdd = () => import('@/views/testimonials/TestimonialsAdd')
const TestimonialsEdit = () => import('@/views/testimonials/TestimonialsEdit')

const Orders = () => import('@/views/Orders')

// Views - Pages
const Settings = () => import('@/views/Settings')
const Profile = () => import('@/views/Profile')
const Dashboard = () => import('@/views/Dashboard')

const Page404 = () => import('@/views/Page404')
const Page500 = () => import('@/views/Page500')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'pois',
          redirect: '/pois/list',
          name: 'Pois',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ListPois',
              component: PointsOfInterest
            },
            {
              path: 'add',
              name: 'AddPoi',
              component: AddPointOfInterest
            },
            {
              path: 'edit',
              name: 'EditPoi',
              component: EditPointOfInterest
            },
  
          ]
        },
        // Members
        {
          path: 'membros',
          redirect: '/membros/lista',
          name: 'Members',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'MembersList',
              component: Members
            },
            {
              path: 'adicionar',
              name: 'MembersAdd',
              component: MembersAdd
            },
            {
              path: 'editar',
              name: 'MembersEdit',
              component: MembersEdit
            },
          ]
        },
         // Heros
         {
          path: 'capa',
          redirect: '/capa/lista',
          name: 'Heros',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'HerosList',
              component: Heros
            },
            {
              path: 'adicionar',
              name: 'HerosAdd',
              component: HerosAdd
            },
            {
              path: 'editar',
              name: 'HerosEdit',
              component: HerosEdit
            },
          ]
        },
        // KeyValues
        {
          path: 'informacoes',
          redirect: '/informacoes/lista',
          name: 'KeyValues',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'lista',
              name: 'KeyValuesList',
              component: KeyValues
            },
            {
              path: 'adicionar',
              name: 'KeyValuesAdd',
              component: KeyValuesAdd
            },
            {
              path: 'editar',
              name: 'KeyValuesEdit',
              component: KeyValuesEdit
            },
          ]
        },
        {
          path: 'categories',
          redirect: '/categories/list',
          name: 'Categories',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ListCategories',
              component: Categories
            },
            {
              path: 'add',
              name: 'AddCategory',
              component: AddCategory
            },
            {
              path: 'edit',
              name: 'EditCategory',
              component: EditCategory
            },
          ]
        },
        {
          path: 'products',
          redirect: '/products/list',
          name: 'Products',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ListProducts',
              component: Products
            },
            {
              path: 'add',
              name: 'AddProduct',
              component: AddProduct
            },
            {
              path: 'edit',
              name: 'EditProduct',
              component: EditProduct
            },
          ]
        },
        {
          path: 'experiences',
          redirect: '/experiences/list',
          name: 'Experiences',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ListExperiences',
              component: Experiences
            },
            {
              path: 'add',
              name: 'AddExperience',
              component: ExperiencesAdd
            },
            {
              path: 'edit',
              name: 'EditExperience',
              component: ExperiencesEdit
            }
          ]
        },
        {
          path: 'testimonials',
          redirect: '/testimonials/list',
          name: 'Testimonials',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ListTestimonials',
              component: Testimonials
            },
            {
              path: 'add',
              name: 'AddTestimonial',
              component: TestimonialsAdd
            },
            {
              path: 'edit',
              name: 'EditTestimonial',
              component: TestimonialsEdit
            }
          ]
        },
        {
          path: 'orders',
          name: 'Orders',
          component: Orders
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings
        },

      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/404',
      name: '404',
      component: Page404
    },    
    {
      path: '/500',
      name: '500',
      component: Page500
    }, 
  ]
}

